import styled from "styled-components";

export const SkillWrapper = styled.div`
    background: transparent;
    text-align: left;
    width: 100%;
    margin: auto;
`;

export const Pad = styled.div`
    padding: 1.5rem;
    position: relative;
    transition: 0.2s;

    @media (min-width: 900px){
        padding-top: ${props => props.top ? '4rem' : '1.5rem'};

        &:hover{
            padding: ${props => props.noanim ? '1.5rem' : '0.5rem'};
         }
    }

`;

export const Skill = styled.div`
    position: relative;
    height: 900px;
    width: 100%;
    background-image: url(${props => (props.src)});
    background-position: center;
    background-size: auto;
    cursor: pointer;

    @media (max-width: 700px){
        height: 225px;
        background-size: cover;
        opacity: 0.8;
    }
}
`;

export const SkillOverlay = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 0;

    @media (max-width: 700px){
        display: none;
    }

    @media (min-width: 700px){
        background-image: linear-gradient(145deg, rgba(0,0,0,0.5) 40%, #0D0E10 40%);
    }
`;

export const Tool = styled.img`
    width: 100%;
    height: 69%;
    z-index: 1;
    position: absolute;
    bottom: 2%;
    left: 0;
    opacity: 0.85;

    @media (max-width: 700px){
        display: none !important;
    }
`;

export const ListTitle = styled.h1`
    color: #fff;
    font-weight: 600;
    font-size: 20px;
    text-transform: uppercase;
    margin-bottom: 2.5rem;
    position: relative;

    &::before {
        content: '';
        display: block;
        position: absolute;
        bottom: -20px;
        margin-top: 20%;
        width: 50%;
        left: 0%;
        border-top: 2px dashed #686238;
    }
`;

export const SkillList = styled.ul`
    list-style: none;
`;

export const ListElement = styled.li`
    margin-bottom: 0.5rem;
    display: flex;
    max-width: 90%;

    &::after{
        content: '${props => props.level}';
        color: #D9A638;
        font-weight: bold;
        font-size: 14px;
    }
`;

export const ElementType = styled.h1`
    color: #3E3F43;
    font-size: 14px;
    font-weight: bold;
`;

export const Dash = styled.div`
    flex: 1;
    margin: auto;
    background: #22252A;
    height: 2px;
    margin:auto 8px;
`;

export const SkillsTitle = styled.h1`
    font-weight: bold;
    font-size: 48px;
    text-transform: uppercase;
    color: #E7E7E8;
    text-align: left;
    margin-bottom: 3rem;
    width: fit-content;
    margin-left: 1.5rem;
    position: relative;

    @media (max-width: 900px){
        margin-top: 3rem;
        font-size: 32px;
        margin-bottom: 0;
    }
`;

export const Strong = styled.strong`
    color: #f0b83d;
    display: block;
`;

export const NextArrowButton  = styled.button`
    max-width: 100%;
    outline: none;
    color: #fff;
    border: 2px solid #F6BF2F;
    margin-right: auto;
    padding: 10px 30px;
    text-transform: uppercase;
    background: transparent;
    z-index: 99999;
    position: absolute;
    top: -140px;
    right: 20px;
    cursor: pointer;
    font-weight: bold;
    cursor: pointer;

    &:hover{
        background: #F0B83D;
        color: #fff;
    }
`;

export const PrevArrowButton = styled.button`
    max-width: 100%;
    outline: none;
    color: #fff;
    border: 2px solid #F6BF2F;
    margin-right: auto;
    padding: 10px 30px;
    text-transform: uppercase;
    background: transparent;
    z-index: 99999;
    position: absolute;
    top: -140px;
    right: 140px;
    cursor: pointer;
    font-weight: bold;
    cursor: pointer;

    &:hover{
        background: #F0B83D;
        color: #fff;
    }
`;


export const SkillsPic = styled.img`
    z-index: -1;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    object-position: bottom;
    object-fit: contain;
`;

export const SkillsOverlay = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    background: linear-gradient(to bottom,rgba(26,30,31, 0.7) 50%, #1A1E1F 100%);
`;

